<template>
  <el-dialog
    v-model="visible"
    :title="title"
    :width="width"
    destroy-on-close
    lock-scroll
    draggable
    :before-close="handleClose"
    :append-to-body="true"
    :show-close="showClose"
    style="border-radius: 12px;"
    class="global-dialog-custom"
  >
    <template #header>
      <span :style="{color: iconColor}">
        <comp-icon v-if="icon" :name="icon" :size="iconSize"></comp-icon>
      </span>
      <div class="header header-text" :style="titleStyle">{{ title }}</div>
    </template>
    <div v-html="content"></div>
    <!-- 个性页面定制 -->
    <div class="global-dialog-delete-org-custom" v-if="organization">
      <div class="organization">{{ organizationTitle }}:</div>
      <div class="node-box">
        <comp-svg name="tree-node"></comp-svg>
        <div class="node-name">{{ organization }}</div>
        <div class="node-level">{{ nodeLevel }}</div>
      </div>
    </div>
    <!-- 个性页面定制 -->
    <div class="global-dialog-delete-org-custom" v-if="measurePoint">
      <div class="organization">{{ measurePointTitle }}</div>
      <div class="node-box">
        <div class="node-name">{{ measurePoint }}</div>
      </div>
    </div>
    <!-- 单个或者多个 -->
    <div class="global-dialog-delete-org-custom" v-if="names.length">
      <div class="label">{{ label }}</div>
      <div class="name-box" v-if="names.length == 1">
        <div class="name-text lineheight-36">{{ names[0] }}</div>
      </div>
      <div class="name-box name-area-box" v-if="names.length > 1">
        <div class="name-tag" v-for="(name, i) in names" :key="i">{{ name }}</div>
      </div>
      <div :class="{notice: type === 'danger'}">{{ notice }}</div>
    </div>

    <!-- 多个输入框 list-->
    <div class="global-dialog-delete-org-custom" v-if="list.length">
      <template v-for="(item, i) in list">
        <div class="label">{{ item.label }}</div>
        <div class="name-box name-area-box" :class="{'disabled': item.disabled}" v-if="Array.isArray(item.value)">
          <div class="name-tag" v-for="(name, i) in item.value" :key="i">{{ name }}</div>
        </div>
        <div class="name-box" :class="{'disabled': item.disabled}" v-else>
          <div class="name-text lineheight-36">{{ item.value }}</div>
        </div>
      </template>
      <div :class="{notice: type === 'danger'}">{{ notice }}</div>
    </div>

    <template #footer>
      <span class="dialog-footer" :style="{ justifyContent: showCancelButton ? 'center' : 'flex-end' }">
        <comp-button v-if="showCancelButton" size="large" :style="cancelButtonStyle" :type="cancelButtonType" @click="handleCancel">{{ cancelButtonText }}</comp-button>
        <comp-button v-if="showConfirmButton" size="large" :style="confirmButtonStyle" :type="confirmButtonType" @click="handleConfirm">
          {{ confirmButtonText }}
        </comp-button>
      </span>
    </template>
  </el-dialog>
</template>

<script setup>
import { ref } from 'vue'
import CompButton from '../comp-button'
import { ElDialog } from 'element-plus'
import CompSvg from '../comp-svg'
import CompIcon from '../comp-icon'
import { Lang } from '@/lang/lang'

const props = defineProps({
  type: {
    type: String,
    default: 'normal',
  },
  icon: {
    type: String,
    default: ''
  },
  iconSize: {
    type: String,
    default: '48px'
  },
  iconColor: {
    type: String,
    default: ''
  },
  title: {
    type: String,
    default: '提示'
  },
  titleStyle: {
    type: String,
    default: ''
  },
  // 删除组织专用
  organizationTitle: {
    type: String,
    default: ''
  },
  measurePointTitle: {
    type: String,
    default: ''
  },
  organization: {
    type: String,
    default: ''
  },
  measurePoint: {
    type: String,
    default: ''
  },
  nodeLevel: {
    type: String,
    default: ''
  },
  content: {
    type: String,
    default: ''
  },
  notice: {
    type: String,
    default: ''
  },
  label: {
    type: String,
    default: ''
  },
  names: {
    type: Array,
    default: () => []
  },
  list: {
    type: Array,
    default: () => []
  },
  cancelButtonText: {
    type: String,
    default: Lang.btn.cancel
  },
  confirmButtonText: {
    type: String,
    default: Lang.btn.confirm
  },
  cancelButtonType: {
    type: String,
    default: 'default'
  },
  confirmButtonType: {
    type: String,
    default: 'primary'
  },
  showClose: {
    type: Boolean,
    default: true,
  },
  showCancelButton: {
    type: Boolean,
    default: true,
  },
  showConfirmButton: {
    type: Boolean,
    default: true,
  },
  width: {
    type: String,
    default: '400px'
  },
  cancelButtonStyle: {
    type: Object,
    default: () => {}
  },
  confirmButtonStyle: {
    type: Object,
    default: () => {}
  },
  onConfirm: {
    type: Function,
    default: () => {}
  },
  onCancel: {
    type: Function,
    default: () => {}
  }
})

const emit = defineEmits(['onConfirm', 'onCancel'])

const visible = ref(false)

const show = () => {
  visible.value = true
}

const hide = () => {
  visible.value = false
}
const open = () => {
  visible.value = true
}
const handleConfirm = () => {
  emit('onConfirm')
  props.onConfirm()
  hide()
}

const handleCancel = () => {
  emit('onCancel')
  props.onCancel()
  hide()
}

const handleClose = (done) => {
  emit('onCancel')
  done()
}

defineExpose({
  show,
  hide,
  open,
})
</script>

<style lang="scss" scoped>
.dialog-footer {
  display: flex;
  justify-content: center;
  padding-top: 16px;
  .comp-button {
    width: 50%;
  }
}

</style>